import React from 'react'
import DynamicColor from '../common/dynamic-color'
import { COLOR_NAME } from '../../constants'
import { useTranslation } from 'react-i18next'
import { clsx } from '../../utils/helper'

const InputSelect = ({
    className = '',
    i18nDataError,
    value = '',
    label,
    error,
    inputStyle,
    required,
    options,
    ...props
}) => {
    const { t } = useTranslation()
    const classes = clsx(['app-select', error && 'error', className])

    return (
        <div className={classes}>
            {label && (
                <DynamicColor
                    style={{ color: COLOR_NAME.BODY_TEXT }}
                    className="app-select__label"
                >
                    {label}
                    {required && (
                        <span className="ml-1 app-select__required">(*)</span>
                    )}
                </DynamicColor>
            )}

            <div className="select-box">
                <select value={value ?? ''} {...props}>
                    {options}
                </select>

                <i className="icon fas fa-caret-down" />
            </div>

            {/* {error && (
                <div className="app-select__error mt-2 text-left">
                    {t(error, { ...i18nDataError })}
                </div>
            )} */}
        </div>
    )
}

export default InputSelect
